// extracted by mini-css-extract-plugin
module.exports = {"containerPage":"PageNotFound_containerPage__1sdbn","linkInicio":"PageNotFound_linkInicio__3uKj8"};